var map = {
	"./alkalmazasok_avi.png": "74fe",
	"./alkalmazasok_css.png": "d4cb",
	"./alkalmazasok_dll.png": "e7d4",
	"./alkalmazasok_doc.png": "3ca2",
	"./alkalmazasok_eps.png": "97d5",
	"./alkalmazasok_html.png": "a282",
	"./alkalmazasok_jpg.png": "2916",
	"./alkalmazasok_mov.png": "8f5c",
	"./alkalmazasok_mp3.png": "9cb7",
	"./alkalmazasok_pdf.png": "fd38",
	"./alkalmazasok_png.png": "c2db",
	"./alkalmazasok_ppt.png": "60b4",
	"./alkalmazasok_psd.png": "3160",
	"./alkalmazasok_txt.png": "f874",
	"./alkalmazasok_unknown.png": "2f43",
	"./alkalmazasok_wav.png": "5e30",
	"./alkalmazasok_xls.png": "1bfc",
	"./alkalmazasok_zip.png": "51af"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2635";